import { put, SagaIterator, takeEveryErrorRequest } from './core/sagaEffects';
import { AddNotification } from 'acscp/actions';
import { ModificationRequest } from 'acscp/api/requests';
import { ResponseErrorTypes, ResponseType } from 'acscp/api/responses/core/responseTypes';
import { ErrorDetails } from 'acscp/api/models/errorDetails';
import history from 'acscp/store/history';

import { getTranslatableErrorMessage } from 'acscp/components/common/helpers/getTranslatableErrorMessage';
import { NotificationType } from 'acscp/store/notificationState';

export function* modificationRequestSaga(): SagaIterator {
    yield takeEveryErrorRequest(ModificationRequest, handleModificationRequestErrors);
}

const modificationRequestFailedCause = 'modificationRequestFailedCause';

export function* handleModificationRequestErrors(
    responseType: ResponseErrorTypes,
    error: ErrorDetails,
    request: ModificationRequest
): SagaIterator {
    // We only add special handling to 4** errors.
    // The default error handling of 500 errors (i.e. simply adding a notification)
    // is the desired behaviour in this case: no need to redirect the user,
    // because they might be able to "fix" the problem by retrying.

    // Each 4** errors that server may return for the modification request
    // mean that the request cannot be submitted for some reason.
    // We redirect the user to the booking page to see the updated state,
    // so they can reconsider their options.

    if (responseType === ResponseType.Conflict) {
        // Conflict errors have additional helpful information - show it.
        yield put(new AddNotification(
            modificationRequestFailedCause, getTranslatableErrorMessage(error.message), NotificationType.Error));
        history.push(`/trip/${request.bookingId}`);
    }
}
